import { z } from 'zod'
import { oc } from '@orpc/contract'
import {
  TASK_FOLLOWUP_ACTION_VALUES,
  TASK_LOG_LEVEL_VALUES,
  TASK_STATUS_VALUES,
  taskSchema,
} from './tasks-shared.contract'

/**
 * Admin edit of a task's admin-owned fields (slug/name are code-owned). Partial: absent
 * fields stay unchanged. schedule must be valid cron (400 otherwise); scheduledArgs are
 * validated against the runner's argsSchema (null clears them). nextRunAt: explicit value
 * wins; otherwise schedule/on_schedule edits recompute it; null lets the scheduler
 * re-initialize from the cron.
 */
export const updateTask = oc
  .route({ method: 'PATCH', path: '/v2/tasks/{slug}' })
  .input(
    z.object({
      slug: z.string().min(1),
      status: z.enum(TASK_STATUS_VALUES).optional(),
      logLevel: z.enum(TASK_LOG_LEVEL_VALUES).optional(),
      onSchedule: z.boolean().optional(),
      schedule: z.string().min(1).nullable().optional(),
      scheduledArgs: z.unknown().optional(),
      maxConcurrentRuns: z.number().int().min(0).max(10).optional(),
      maxInstanceRuns: z.number().int().min(0).max(10).optional(),
      followupAction: z.enum(TASK_FOLLOWUP_ACTION_VALUES).optional(),
      nextRunAt: z.iso.datetime().nullable().optional(),
    }),
  )
  .output(z.object({ data: taskSchema }))
